import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import { ASSET_ITEM_URL } from '../../Constants/Constants'
import AxiosInstance from '../../services/AxiosInstance'
import AppTableView from '../AppTableView'
import AssetDetails from './AssetDetails'
import AssetItemDialog from './AssetItemDialog'
import Tooltip from "@mui/material/Tooltip"

function AssetItem() {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))

  const [assetItemData, setAssetItemData] = useState([])

  useEffect(() => {
    getAssetItems()
  }, [])

  const getAssetItems = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(ASSET_ITEM_URL).then((response) => {
      setAssetItemData(response.data.data)
    })
  }


  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <AssetItemDialog
          assetItemId={0}
          selectedItemName={""}
          callAssetItems={getAssetItems}
          actionType={"Add"}
          isEdit={false}
        />
      </Box>

      <AppTableView
        rows={assetItemData}
        initialPageSize={15}
        cols={[
          {
            field: "name", headerName: "Asset Item", flex: 1,
            minWidth: 120,
            renderCell: (params) => {
              return (
                <Tooltip
                  title={params.value || ""}
                  arrow
                >
                  <AssetItemDialog
                    assetItemId={params.row.id}
                    selectedItemName={params.value}
                    callAssetItems={getAssetItems}
                    actionType={"Edit"}
                    isEdit={true}
                  /></Tooltip>
              );
            }
          },
          {
            field: "assetType",
            headerName: "Asset Type",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.valu?.name}>{params.value?.name}</Tooltip>
            }
          },
          {
            field: "assetClass",
            headerName: "Asset Class",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.valu?.name}>{params.value?.name}</Tooltip>
            }
          },
          {
            field: "user",
            headerName: "Assigned User",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.valu?.username}>{params.value?.username}</Tooltip>
            }
          },
          {
            field: "organization",
            headerName: "Organization",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.valu?.name}>{params.value?.name}</Tooltip>
            }
          },
          {
            field: "location",
            headerName: "Location",
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.valu}>{params.value}</Tooltip>
            }
          },
          {
            field: "assetTag",
            headerName: "Asset Tag",
            flex: 1,
            minWidth: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return <Tooltip title={params.value}>{params.value}</Tooltip>
            }
          },
          {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 130,
            renderCell: (params) => {
              return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
          },
          {
            field: "assetStatus",
            headerName: "Status",
            flex: 1,
            minWidth: 100,
            renderCell: (params) => {
              return (
                <Tooltip
                  title={params.value?.name || ""}
                  arrow
                >
                  <Chip
                    label={params.value?.name}
                    size="small"
                    sx={{
                      backgroundColor: params.value?.color || "#9E9E9E",
                      color: '#000000',
                      fontWeight: 600
                    }}
                  /></Tooltip>

              )
            },
          },
          {
            field: 'info',
            headerName: 'Info',
            flex: 1,
            renderCell: (params) => (
              <AssetDetails
                editAssetId={params.row.id}
                selectedAssetName={params.row.name}
              />
            ),
          },
        ]}
      />
    </Container>
  )
}

export default AssetItem
